import { toast } from 'react-toastify';
import { FileUploadFile } from 'primereact/fileupload';
import appApi from '../../../../../../../../api/app-api';
import { uploadFileAndRetrieveFileUrl } from '../../../../../../../../api/operations/files/upload-file-and-retrieve-file-url';
import { HttpStatusCode } from 'axios';
import globalCourseStore from '../../../../../../../../stores/global-course-store';

export const uploadFileOperation = async (
  programId: number | undefined,
  courseId: number | undefined,
  assignmentId: number | undefined,
  file: FileUploadFile | undefined,
  setLoading: (loading: boolean) => any,
  hideDialog: (display: boolean) => any,
  onHide: () => any,
) => {
  try {
    if (!programId || !courseId || !assignmentId) {
      toast.warn(
        'לא ניתן לאתר את המזהה של התוכנית ו/או הקורס, נסה שוב בעוד מספר רגעים...',
      );
      return;
    }
    if (!file) {
      toast.warn('תחילה יש להעלות קובץ');
      return;
    }

    const fileExtension = file.name.split('.').pop();
    if (!fileExtension?.length) {
      toast.warn(
        'לא ניתן לאתר את סוג הקובץ, נסה להוסיף סיומת לקובץ והעלאה מחדש',
      );
      return;
    }

    setLoading(true);

    const preSignUrlRes = await appApi.getAssignmentPreSignUrl(
      programId!,
      courseId!,
      assignmentId,
      fileExtension,
    );

    const fullUrl = await uploadFileAndRetrieveFileUrl(
      preSignUrlRes.data.body,
      file,
    );

    if (!fullUrl) {
      throw new Error('Can not find uploaded path');
    }

    const preSignUrlRes2 = await appApi.uploadAssignmentFile(
      programId!,
      courseId!,
      assignmentId,
      fullUrl,
      file.name,
    );

    setLoading(false);

    if (preSignUrlRes2.status === HttpStatusCode.Ok) {
      globalCourseStore.updateCourseDetails(
        courseId,
        preSignUrlRes2.data.body.metadata,
        preSignUrlRes2.data.body.details,
      );
    }

    hideDialog(false);
    onHide();
  } catch (e) {
    setLoading(false);
    toast.error('העלאת קובץ נכשלה, נסה שוב בעוד מספר רגעים...');
    console.error(
      `uploadFileOperation is failed with the programId: ${programId}, courseId: ${courseId}, assignmentId: ${assignmentId}, fileName: ${file?.name} with the error: ${e}`,
    );
  }
};
